const crmHelpGetApiToken = {
  hubspot: {
    key: 'hubspot',
    value: 1,
    link: 'https://knowledge.hubspot.com/integrations/how-do-i-get-my-hubspot-api-key',
  },
  pipedrive: {
    key: 'pipedrive',
    value: 2,
    link: 'https://pipedrive.readme.io/docs/how-to-find-the-api-token#:~:text=You%20can%20get%20the%20API,of%20the%20last%20opened%20company).',
  },
  mailchimp: {
    key: 'mailchimp',
    value: 3,
    link: 'https://support.checkfront.com/hc/en-us/articles/115004180154-Mailchimp-Setup-API-Key',
  }
}
export const constants = {
  crmHelpGetApiToken
}
